<template>
  <div v-if="!$root.isMobile">
    <!-- Workspace box -->
    <!-- Workspace form -->
    <box class="mb-30 large-page-box" :padding="60">
      <template v-slot:content>
        <div class="w-100 fs-20 lh-20 mb-15 fw-b">{{ $t(`${$options.name}.title`) }}</div>
        <div class="d-flex mb-0 pb-30 border-bottom">
          <i class="fs-30 fal fa-envelope-open-text mr-15 my-auto"></i>
          <div class="fs-15 text-light mb-0">{{ $t(`${$options.name}.description_invited`) }}</div>
        </div>
        <hr />
        <div class="d-flex mb-30">
          <i class="fal fa-plus-square fs-30 mr-15 my-auto"></i>
          <div class="fs-15 text-light mb-0">{{ $t(`${$options.name}.description`) }}</div>
        </div>

        <el-form
          @submit="submit()"
          :error="server_error"
          :loading="loading"
          :disabled="exists || loading"
          :success="success"
          :button-text="`${$options.name}.button`"
        >
          <div class="form-row">
            <el-input
              v-model="workspace.company"
              class="col-12 mb-15"
              rule="required|min:2|max:255"
              name="company"
            />
            <el-input
              v-model="workspace.name"
              class="col-12 mb-15"
              rule="required|min:2|max:255"
              @input="suggestDomain"
              name="onboarding_workspace_title"
            />
            <el-input
              v-model="workspace.slug"
              class="col-8 mb-10"
              rule="required|min:2|max:255"
              name="workspace"
              @input="
                (v) => {
                  check();
                  workspace.slug = slugify(v);
                }
              "
            />
            <div class="form-group col-4 fs-20 fw-b">
              <label for="">&#160;</label>
              <div>.appvalvas.com</div>
            </div>
          </div>
          <template v-if="workspace.name.length > 0">
            <div v-if="!exists" class="fs-11 text-primary">
              <i-check class="i-13 mr-5 fill-primary"></i-check>
              {{ $t(`${$options.name}.workspace_available`) }}
            </div>
            <div v-else class="fs-11 text-danger">
              <i-close class="i-13 mr-5 fill-danger"></i-close>
              {{ $t(`${$options.name}.workspace_unavailable`) }}
            </div>
          </template>
          <template v-slot:footerLeft v-if="currentWorkspace">
            <router-link
              :to="{ name: 'workspace', params: { id: currentWorkspace.id } }"
              class="text-light my-auto"
            >
              {{ $t('general.back') }}
            </router-link>
          </template>
        </el-form>
      </template>
    </box>
  </div>
  <use-desktop-version v-else>
    {{ $t('mobile.no_workspace') }}
  </use-desktop-version>
</template>

<script>
import { _ } from 'vue-underscore';
import HasForm from '@/components/forms/has-form';

export default {
  name: 'views.onboarding.workspace',

  mixins: [HasForm],

  components: {
    ElForm: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElForm'),
    ElInput: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElInput'),
  },

  props: {
    workspace: {
      default: () => {
        return {
          id: false,
          company: '',
          name: '',
          slug: '',
        };
      },
    },
  },

  data() {
    return {
      exists: false,
    };
  },

  mounted() {
    const root = document.documentElement;
    root.style.setProperty('--primary', '#ED8B00');
    root.style.setProperty('--primary-highlight', '#f1f9fc');
  },

  methods: {
    check: _.debounce(function() {
      this.$store.dispatch('workspace/verify', this.workspace).then((res) => {
        this.exists = res.exists;
      });
    }, 500),

    suggestDomain() {
      this.workspace.slug = this.slugify(this.workspace.name);

      this.check();
    },

    submit() {
      this.loading = true;

      // Handle creation of a new workspace
      if (!this.workspace.id)
        this.$store
          .dispatch('workspace/create', this.workspace)
          .then(() => {
            this.handleSuccess({ toast: true, toast_text: this.$t('toast.workspace.created') });
            this.$router.push({ name: 'container-create', query: { create: true } });
          })
          .catch((e) => this.handleError(e));

      // Handle update of a new workspace
      if (this.workspace.id)
        this.$store
          .dispatch('workspace/update', {
            workspace_id: this.workspace.id,
            workspace: this.workspace,
          })
          .then(() => {
            this.handleSuccess({ toast: true, toast_text: this.$t('toast.workspace.updated') });
            this.$router.push({ name: 'container-create' });
          })
          .catch((e) => this.handleError(e));
    },
  },
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
    currentWorkspace() {
      return this.$store.getters['workspace/current'];
    },
    workspaces() {
      return this.$store.getters['workspace/all'];
    },
  },
};
</script>
